import axios from 'axios';

export const BASE_URL = `${process.env.REACT_APP_URL}`;
// export const BASE_URL = `http://127.0.0.1:8000`;

export const networkService = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 30000,
});
